import {Vec2, Side} from './index.h'
import {SIDE} from './env'

export function convertCellsToSides(first: Vec2, cells: Vec2[]): Side[] {
  const sides: Side[] = []
  let prev = first
  for (const cell of cells) {
    const diffXAbs = Math.max(prev.x, cell.x) - Math.min(prev.x, cell.x)
    const diffYAbs = Math.max(prev.y, cell.y) - Math.min(prev.y, cell.y)
    if (diffXAbs > 1 || diffYAbs > 1) throw Error('sparse path')
    if (diffYAbs > 1) throw Error('sparse path')
    if (diffXAbs === 0 && diffYAbs === 0) throw Error('point duplicate')
    if (diffXAbs === 1 && diffYAbs === 1) throw Error('diagonal movement')
    const diffX = cell.x - prev.x
    const diffY = cell.y - prev.y
    if (diffX === 1) sides.push(SIDE.RIGHT)
    if (diffX === -1) sides.push(SIDE.LEFT)
    if (diffY === 1) sides.push(SIDE.DOWN)
    if (diffY === -1) sides.push(SIDE.UP)
    prev = cell
  }
  return sides
}
